import { useCallback } from 'react'

export function useRipple(color = 'rgba(255, 255, 255, 0.3)') {
  const triggerRipple = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const target = e.currentTarget
    const rect = target.getBoundingClientRect()
    const size = Math.max(rect.width, rect.height)
    const x = e.clientX - rect.left - size / 2
    const y = e.clientY - rect.top - size / 2

    const ripple = document.createElement('span')
    ripple.style.cssText = `
      position: absolute;
      border-radius: 50%;
      width: ${size}px;
      height: ${size}px;
      left: ${x}px;
      top: ${y}px;
      background: ${color};
      transform: scale(0);
      animation: rippleEffect 0.6s ease-out forwards;
      pointer-events: none;
      z-index: 0;
    `
    target.style.position = 'relative'
    target.style.overflow = 'hidden'
    target.appendChild(ripple)

    setTimeout(() => ripple.remove(), 600)
  }, [color])

  return triggerRipple
}
